import React from 'react';

const AdArea: React.FC = () => {
  return (
    <div 
      className="ad-area text-center py-3 mb-3 rounded"
      style={{ 
        backgroundColor: 'var(--bingo-card-bg)',
        border: '1px dashed var(--bingo-border)',
        minHeight: '60px'
      }}
    >
      <span className="text-muted small">PUBLICIDADE</span>
    </div>
  );
};

export default AdArea;
